import React from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  FormControl,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  CardHeader,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Delete as DeleteIcon } from "@mui/icons-material";

const ClientContact = ({
  clientContacts,
  handleContactChange,
  handleAddContact,
  handleRemoveContact,
  handleContactDetailsChange,
  handleAddNumber,
  handleRemoveNumber,
  handleAddEmail,
  handleRemoveEmail,
  handleContactCheckboxChange,
  loading,
  errors,
}) => {
  const renderContactFields = (contact, index) => (
    <Card key={index} sx={{ marginBottom: "16px" }} variant="outlined">
      <CardContent sx={{ padding: "24px" }}>
        <Grid container spacing={3}>
          <Grid item container spacing={2}>
            {/* First Name and Last Name Fields */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                fullWidth
                value={contact.firstname}
                onChange={(e) =>
                  handleContactChange(index, "firstname", e.target.value)
                }
                required
                size="small"
                disabled={loading}
                error={!!errors[`contacts[${index}].firstname`]}
                helperText={errors[`contacts[${index}].firstname`]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                fullWidth
                value={contact.lastname}
                onChange={(e) =>
                  handleContactChange(index, "lastname", e.target.value)
                }
                required
                size="small"
                disabled={loading}
                error={!!errors[`contacts[${index}].lastname`]}
                helperText={errors[`contacts[${index}].lastname`]}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            {contact.numbers.map((number, numberIndex) => (
              <React.Fragment key={numberIndex}>
                {contact.numbers.length > 1 ? (
                  <>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="contact-type-label">
                          Contact Type
                        </InputLabel>
                        <Select
                          labelId="contact-type-label"
                          value={number.type}
                          onChange={(e) =>
                            handleContactDetailsChange(
                              index,
                              "numbers",
                              numberIndex,
                              "type",
                              e.target.value
                            )
                          }
                          label="Contact Type"
                          disabled={loading}
                          error={
                            !!errors[
                              `contacts[${index}].numbers[${numberIndex}].type`
                            ]
                          }
                          helperText={
                            errors[
                              `contacts[${index}].numbers[${numberIndex}].type`
                            ]
                          }
                        >
                          <MenuItem value="mobile">Mobile</MenuItem>
                          <MenuItem value="landline">Landline</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={7}>
                      <TextField
                        label="Contact Number"
                        fullWidth
                        value={number.number}
                        onChange={(e) =>
                          handleContactDetailsChange(
                            index,
                            "numbers",
                            numberIndex,
                            "number",
                            e.target.value
                          )
                        }
                        size="small"
                        disabled={loading}
                        error={
                          !!errors[
                            `contacts[${index}].numbers[${numberIndex}].number`
                          ]
                        }
                        helperText={
                          errors[
                            `contacts[${index}].numbers[${numberIndex}].number`
                          ]
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{ height: '40px' }}
                      >
                        <Tooltip title="Delete">
                          <span>
                            <IconButton
                              onClick={() =>
                                handleRemoveNumber(index, numberIndex)
                              }
                              disabled={loading}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={5} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="contact-type-label">
                          Contact Type
                        </InputLabel>
                        <Select
                          labelId="contact-type-label"
                          value={number.type}
                          onChange={(e) =>
                            handleContactDetailsChange(
                              index,
                              "numbers",
                              numberIndex,
                              "type",
                              e.target.value
                            )
                          }
                          label="Contact Type"
                          disabled={loading}
                          error={
                            !!errors[
                              `contacts[${index}].numbers[${numberIndex}].type`
                            ]
                          }
                          helperText={
                            errors[
                              `contacts[${index}].numbers[${numberIndex}].type`
                            ]
                          }
                        >
                          <MenuItem value="mobile">Mobile</MenuItem>
                          <MenuItem value="landline">Landline</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={7} md={8}>
                      <TextField
                        label="Contact Number"
                        fullWidth
                        value={number.number}
                        onChange={(e) =>
                          handleContactDetailsChange(
                            index,
                            "numbers",
                            numberIndex,
                            "number",
                            e.target.value
                          )
                        }
                        size="small"
                        disabled={loading}
                        error={
                          !!errors[
                            `contacts[${index}].numbers[${numberIndex}].number`
                          ]
                        }
                        helperText={
                          errors[
                            `contacts[${index}].numbers[${numberIndex}].number`
                          ]
                        }
                      />
                    </Grid>
                  </>
                )}
              </React.Fragment>
            ))}{" "}
          </Grid>
          <Grid item container spacing={2}>
            {contact.emails.map((email, emailIndex) => (
              <React.Fragment key={emailIndex}>
                {contact.emails.length > 1 ? (
                  <>
                    <Grid item xs={10} sm={10} md={10}>
                      <TextField
                        label="Email Address"
                        fullWidth
                        value={email.email}
                        onChange={(e) =>
                          handleContactDetailsChange(
                            index,
                            "emails",
                            emailIndex,
                            "email",
                            e.target.value
                          )
                        }
                        size="small"
                        disabled={loading}
                        error={
                          !!errors[
                            `contacts[${index}].emails[${emailIndex}].email`
                          ]
                        }
                        helperText={
                          errors[
                            `contacts[${index}].emails[${emailIndex}].email`
                          ]
                        }
                      />
                    </Grid>

                    <Grid item xs={2} sm={2} md={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{ height: '40px' }}
                      >
                        <Tooltip title="Delete">
                          <span>
                            <IconButton
                              onClick={() =>
                                handleRemoveEmail(index, emailIndex)
                              }
                              disabled={loading}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    <TextField
                      label="Email Address"
                      fullWidth
                      value={email.email}
                      onChange={(e) =>
                        handleContactDetailsChange(
                          index,
                          "emails",
                          emailIndex,
                          "email",
                          e.target.value
                        )
                      }
                      size="small"
                      disabled={loading}
                      error={
                        !!errors[
                          `contacts[${index}].emails[${emailIndex}].email`
                        ]
                      }
                      helperText={
                        errors[`contacts[${index}].emails[${emailIndex}].email`]
                      }
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>

          <Grid item container spacing={2} alignItems="center" sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={contact.billing}
                    onChange={() => handleContactCheckboxChange(index)}
                    disabled={loading}
                    size="small"
                  />
                }
                label="Set as Billing Contact"
                sx={{
                  margin: 0,
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem'
                  },
                  '& .MuiCheckbox-root': {
                    padding: '4px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                onClick={() => handleAddNumber(index)}
                size="small"
                sx={{ fontSize: "0.875rem", width: "100%" }}
                disabled={loading}
              >
                Add Another Number
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                onClick={() => handleAddEmail(index)}
                size="small"
                sx={{ fontSize: "0.875rem", width: "100%" }}
                disabled={loading}
              >
                Add Another Email
              </Button>
            </Grid>

            {clientContacts.length > 1 && (
              <Grid item xs={12} sm={12} md={3}>
                <Button
                  color="error"
                  size="small"
                  onClick={() => handleRemoveContact(index)}
                  disabled={loading}
                  sx={{ width: "100%" }}
                >
                  Remove Contact Person
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <Grid container>
      <CardHeader
        title={
          <Box display="flex" alignItems="center" width="100%" flexWrap="wrap">
            <Grid container spacing={2} alignItems="center" mb={2}>
              <Grid item xs={12} sm="auto">
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                  mr={2}
                >
                  Contact Person
                </Typography>
              </Grid>
              <Grid item xs={12} sm="auto">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleAddContact}
                  size="small"
                  disabled={loading}
                  sx={{ fontSize: "0.875rem" }}
                >
                  Add Another Contact Person
                </Button>
              </Grid>
            </Grid>
          </Box>
        }
        sx={{ padding: "16px" }}
      />
      <Grid item xs={12}>
        {clientContacts.map((person, index) =>
          renderContactFields(person, index)
        )}
      </Grid>
    </Grid>
  );
};

export default ClientContact;
